import React, { useEffect } from "react";
import { connect } from "react-redux";

import BaseMapStyle, { isDarkMapStyle } from "@mapmycustomers/shared/enum/map/BaseMapStyle";
import LongLat from "@mapmycustomers/shared/types/base/LongLat";

import { useMap } from "@app/component/map/FeaturedMap";
import localSettings from "@app/config/LocalSettings";
import {
  getCenterPoint,
  getLeadFinderSearchDistance,
  hasCenterPoint,
} from "@app/scene/map/store/leadFinder/selectors";
import { getMapStyle } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";
import colors from "@app/styles/_colors.module.scss";
import { METERS_IN_MILE } from "@app/util/consts";

interface Props {
  mapStyle: BaseMapStyle;
  point?: LongLat;
  radius: number;
  visible: boolean;
}

const CenterPointCircle: React.FC<Props> = ({ mapStyle, point, radius, visible }) => {
  const { map } = useMap();
  const color = isDarkMapStyle(mapStyle) ? colors.white : colors.softSlate;

  const doesUseSiUnits = localSettings.doesUseSiUnits();
  const radiusMeters = doesUseSiUnits ? radius * 1000 : radius * METERS_IN_MILE;

  useEffect(() => {
    if (visible && point) {
      const center: google.maps.LatLngLiteral = {
        lat: point[1],
        lng: point[0],
      };

      const circle = new google.maps.Circle({
        center,
        clickable: false,
        fillColor: color,
        fillOpacity: 0.2,
        map,
        radius: radiusMeters,
        strokeColor: color,
        strokeWeight: 1,
        zIndex: 0,
      });

      const marker = new google.maps.Marker({
        clickable: false,
        icon: {
          fillColor: color,
          fillOpacity: 1,
          path: google.maps.SymbolPath.CIRCLE,
          scale: 6.5,
          strokeWeight: 0,
        },
        map,
        position: center,
        zIndex: 0,
      });

      return () => {
        marker.setMap(null);
        circle.setMap(null);
      };
    }
  }, [color, map, point, radiusMeters, visible]);

  return null;
};

const mapStateToProps = (state: RootState) => ({
  mapStyle: getMapStyle(state),
  point: getCenterPoint(state),
  radius: getLeadFinderSearchDistance(state),
  visible: hasCenterPoint(state),
});

export default connect(mapStateToProps)(CenterPointCircle);
